var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePattern({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1430,
    height: 869,
    viewBox: "0 0 1430 869",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586.047,
    height: 113.572,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 574.881 603.236)",
    fill: "url(#pattern0_8_23)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 586.047,
    height: 113.572,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 830.284 396.591)",
    fill: "url(#pattern1_8_23)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 586.047,
    height: 113.572,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 787.403 295.083)",
    fill: "url(#pattern2_8_23)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 586.047,
    height: 113.572,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 742.204 185.29)",
    fill: "url(#pattern3_8_23)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 586.047,
    height: 113.572,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 -308.96 657.609)",
    fill: "url(#pattern4_8_23)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 586.047,
    height: 113.572,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 -353 549.887)",
    fill: "url(#pattern5_8_23)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 580.45,
    height: 113.572,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 280.416 583.16)",
    fill: "url(#pattern6_8_23)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 580.45,
    height: 113.572,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 237.535 478.545)",
    fill: "url(#pattern7_8_23)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 580.45,
    height: 113.572,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 192.336 372.895)",
    fill: "url(#pattern8_8_23)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 591.61,
    height: 114.65,
    transform: "matrix(0.948703 -0.316169 0.385057 0.922893 -268.764 762.271)",
    fill: "url(#pattern9_8_23)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0397238,
    height: 0.141584
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_23",
    transform: "scale(0.000204762 0.00105659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0397238,
    height: 0.141584
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_23",
    transform: "scale(0.000204762 0.00105659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0397238,
    height: 0.141584
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_23",
    transform: "scale(0.000204762 0.00105659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0397238,
    height: 0.141584
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_23",
    transform: "scale(0.000204762 0.00105659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0397238,
    height: 0.141584
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_23",
    transform: "scale(0.000204762 0.00105659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0397238,
    height: 0.141584
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_23",
    transform: "scale(0.000204762 0.00105659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0190197,
    height: 0.0739616
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_8_23",
    transform: "scale(0.000206736 0.00105659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0190197,
    height: 0.0739616
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_8_23",
    transform: "scale(0.000206736 0.00105659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0190197,
    height: 0.0739616
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_8_23",
    transform: "scale(0.000206736 0.00105659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9_8_23",
    patternContentUnits: "objectBoundingBox",
    width: 0.0393503,
    height: 0.140252
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_23",
    transform: "scale(0.000202836 0.00104666)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8_23",
    width: 194,
    height: 134,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAACGCAYAAACPKFVLAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQzSURBVHgB7dzbURxHFAbg4RLAOgKTgZSBUATWSujZUgSCCLREAERg9MrdEQgiMGSAM0DvXPwf3FOFq2SDQWiX1fdVTU3PzD722T6nu2e6DgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4wvb395/v7u4ud/CjSzAsbG1tPe/gX8x3UywBMMipjrO5ubm1nIcdfMVsN6VqFLi4uBhdXV391m4dJUV618FXTF0gVACkw+9XACwtLS3PzMysXF5efnzz5s16Hv/SRgn4h6kKhCqMKwDS6Yc5/76zs/NqOBwepz1Tz2ZnZ9/n+qyDaZRO/rGOatdoUKPCjbYRgFs96WK5OnzSng9pbqQeWM71Ytor7d5KRoCVDu5gpnuCWoc/q7Rnb2/vc+qAYaU8fTuB8CpBcCAN4q4mOhD66c906NP+XtKdj+no6e8zNRqs5zxIp19MXTCqOqD7O0BOO/gfJj41qhmfnN5XJ0/6s5BOv5FjUPezNlCzQcMqiuu3NUJ0cA8Tnxq1uf9BZn5O0/Hr3/4wHf9z2pUC1RrBSY0GHTzAxARCP7vT5/XteqH+5du6wJekQVcZDVZbDfAsz1elQXwLE5ManZ+f1zz/YpqjSnXS2WtNYCEBsZlnGwmCtTwf1mpx1QZtgQy+ibGPCDcL3ATAZlKeUV3XswTAcjr/z+n07/NsPc/WjQA8hrEGQoJgLZ39S0tzjnLerLy/CuCkQ6O6zqiwnONMHcBjGlsgVA2QNGdzaWnpesan6oDaAlGjwPz8/GGlRrn9IkHwKb856GBaJd35o29vb28v1ijQ7m+2RTOYfjU12nf+UivDHYzBd0uNKhWqRbCkP6cpeDf6+/XvX9OiadYK8apFMcbhuwVCqwFqQ1zVBIObxW/bLXpmbxDj8qjrCJXnp+PXtoiDnOtWzf6sV1Dc/J0pUcbt0V7MSRDUothiTX1WSpRjI8davy8IJsmDA+Hmiy/V7md7aqU4QXBcU585/5Qp0dPaMFe7RmuatIMJ8qDUqBXAtfFt2F6SWctxktSntkus13WeHbRiuN8dqhhm4jy4WG4fzzpLxz+s65YOfZibm3tZhXG1c6y8ffv2sIMJde/UqKVBg/7rEDmqFlisZxkBPmXVuGaJajQ4TVpkFGCi3WtE6NOgtjX6OO3j2jnaZofqRZqjfneot8Z4Cm4NhP5DWbULtIrfdPCVrADXK5LXO0Fv7hHKubM5jqfo1tSo/vlr+/Pr169f5vLPqgkSGPXP/6795CTHIDXASBDwVN0lEGr+/9dqt3TnReX8GR0GCYrrzylKe/gh1Esx/fpAbZKzM5Rpc6d1hHprrNYLEgA1QjzLCDDqYIrcafq0bYY7SkFc3w/yaXUAAAAAAAAAAAAAAAAAAAAAAAAAgP/0F2eOQTvHNVAOAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_8_23",
    width: 92,
    height: 70,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABGCAYAAABBovOlAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPASURBVHgB7ZrbUSJBGIV/kPJ12QiWDJwM1AiW8fYKRgBG4BABYwS6z16GDHaMYDGC1Qzw1eueg91VlGWtUAJz4XxVU9098HTm1Om//xkzIYQQQgghhBBCCCGEEEIIIYQQmXN5eXlqYrkkSbJlGVO1kgOR6xNCtzBvWIbUrOS8vr4mLy8vdxcXF3Use5j3MYaWEaV1ODI7ubq6+lOpVHp7e3ttjC3cHkHwG7g8sIwopcOd0IeYjnAd40oh9AnG7v7+fmQZUhqHw7UduLrPzEaMnEDgrTAMb5+enu6Y4RA6rVarsWVMKQSn2BD4OwSl0P3d3d0z3N6k+LVajSLT6YYHMLKMKazgFBMbYZNzuJhip3Q0N0g6Guve4+NjgyLjGlpOKITg7zc5lnbPz88xoiNAjER0MebMauMcolPo4cHBQW6E9hRCcIjb9vUzBcYwYuUBF4+wOW5iXcd/enQ8He0iJZcUQvC1tbXI1c8GkX9QVAhPwVM4O4XYdPkQD2FgOadiOYPZ7Dc3zjEEWKcQuMt7ELiFB3CEKfO6j+saFUjm1ce05EpwV9IlOzs724wQJ+gNnGyIicjX19gkmxgL4ej35ELwSSefn5+zwthyNXOd9TQeQgeuDiF0A/cbec7oz8hccFfa8eIG+A1iHvJYDmGPkM0BxKbIjJifvMfSzwpM5oIjJn4zQjiHuyNGBdw8hLM7PMhA8FNc14wUKwF5qFJufPvUnQqPnYvvIHqbD6MsYucC5jcjxK8n52Vk6ZHi+h7M5ROfx67k27C3nsd9mR29VMF5WIHYbCgNmM0+u4k/SRZ9U/yMhQvu6mmeCs8wNiH0Letnuto1nHLX71gkC900naP7EHbs6IeHhwHmHTaj2Hgy1zZdJRYiOAXlZgixb7Ect0fZXFpfX+cJ8RD3A5R+cdnj4yPmEik4vMReQNTVMcQdwckb2PxC/xv+FjC/i3xKnAdzcTgF9d08ODjGpphiZLnXZacPDyDBsTxYdbHJlwXnpujetPgDDN+Mt9xLXPaqA8x/8SGY+Fqk8PMxbH4VuPgvljyGJxA3hODjz8omex/smRSxuzdvphLcdfM6iAZ28cy1SHl4YUzE7IHQwbjH37oQtmniQ6aKFAjZxVWBkNuuyujzDYu9RQZ7IAO2UfkpgsT+P1NHCrt6jAu+jfGOhuPr/KIJUXLPzXEVy7xZmfrLK9bRiBD2PCLnaGZyhPXK5/IsTF2lMC4wbLASgdjHPKqbmJmZykL3FqZdhjcvQgghhBBCCCGEEEIIIYRYHP8A3h8uzvhOBIQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePattern);
export default __webpack_public_path__ + "static/media/home-pattern.62a39daaee4c5b9b2af750064b74c524.svg";
export { ForwardRef as ReactComponent };